import UqudoAPI from '@/api/uqudo'

const state = {
  isGetStarted: true,
  isBeginVerification: false,
  isStartUqudo: false,
}

const getters = {
  isGetStarted: (state) => state.isGetStarted,
  isBeginVerification: (state) => state.isBeginVerification,
  isStartUqudo: (state) => state.isStartUqudo,
}

const mutations = {
  SET_GET_STARTED(state, value) {
    state.isGetStarted = value
  },
  SET_BEGIN_VERIFICATION(state, value) {
    state.isBeginVerification = value
  },
  SET_START_UQUDO(state, value) {
    state.isStartUqudo = value
  },
}

const actions = {
  async logUserAction(_, { sessionId, event }) {
    const { data, header } = await UqudoAPI.logUserAction(sessionId, event)
    return { data, header }
  },
  async fetchLinkStatus(_, sessionId) {
    const { data, header } = await UqudoAPI.fetchLinkStatus(sessionId)
    return { data, header }
  },
  setGetStarted({ commit }, value) {
    commit('SET_GET_STARTED', value)
  },
  setBeginVerification({ commit }, value) {
    commit('SET_BEGIN_VERIFICATION', value)
  },
  setStartUqudo({ commit }, value) {
    commit('SET_START_UQUDO', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
